import React from "react";
import { useKey } from "rooks";
import CornerstoneViewport from "react-cornerstone-viewport";
import { Grid, IconButton, Tooltip } from "@mui/material";
import { Typography } from "@mui/material";
import { Container } from "@mui/material";
import { Collapse } from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { MenuItem } from "@mui/material";
import { FormControl } from "@mui/material";
import { Button } from "@mui/material";
import { Box } from "@mui/material";
import { openViewer } from "../UniversalViewer/useBasicUniversalViewer";
import { ExpandMore } from "../../Functions/ScreenOperation/ExpandMore";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import InfoIcon from "@mui/icons-material/Info";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import LaunchOutlinedIcon from "@mui/icons-material/LaunchOutlined";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { activeTools } from "../../Environment/Config";
import ViewerTools from "./ViewerTools";
import { useWindowDimensions } from "../../Functions/ScreenOperation/useWindowDimension";
import { MstaFontFamily } from "../../Functions/Style/MstaFont";
import {
  basicDicomFilesRef,
  extractBasicDicom,
} from "../../Functions/Dicom/readDicomDataAsArray";
import { getDataByGasType } from "../../Functions/APIservice/gasAPI";

const cornerstone = require("cornerstone-core");
const cornerstoneTools = require("cornerstone-tools");

type BasicViewerServiceType = {
  dicomDatas: getDataByGasType[];
  title: string;
  subParts: string[];
  selectSubPart: string;
};

export function BasicUniversalViewerService(props: BasicViewerServiceType) {
  const title = props.title;
  const selectSubPart = props.selectSubPart;
  const subParts = props.subParts;
  const [dicomDatas, setDicomDatas] = React.useState<getDataByGasType[]>(
    props.dicomDatas.filter((value) => value.subPart == subParts[0])
  );

  const [viewerExpanded, setViewerExpanded] = React.useState(true);
  const { width } = useWindowDimensions();
  //Singleで表示させる画像Indexのリスト番号
  const [activeNumber, setActiveNumber] = React.useState("");
  const [dicomFiles, setDicomFiles] = React.useState<basicDicomFilesRef[]>([]);

  //一画面で表示させる画像のpathリストのデータセット
  const [imageIds, setImageIds] = React.useState<string[]>([]); //urlのlist

  const [imageInfo, setImageInfo] = React.useState(true);
  const [update, setUpdate] = React.useState(false);
  //表示させる画像の高さ
  const [indexValue, setIndexValue] = React.useState(0);
  //表示させるsubPartsのリスト番号
  const [dicomPartsNum, setDicomPartsNum] = React.useState<number>(0);

  const [ViewerActiveTool, setViewerActiveTool] = React.useState("Wwwc");
  const [totalLoadingImage, setTotalLoadingImage] = React.useState(0);
  const [loadingImageIndex, setLoadingImageIndex] = React.useState(0);
  const [showLoading, setShowLoading] = React.useState(false);
  const [judgeViewer, setJudgeViewer] = React.useState(true);
  const [isFinished, setIsFinished] = React.useState(true);
  const intervalRef = React.useRef<NodeJS.Timeout | null>(null);

  const handleMouseDown = (increment: number) => {
    intervalRef.current = setInterval(() => {
      setIndexValue((prev) => {
        if (increment < 0) {
          return Math.max(prev + increment, 0);
        } else {
          return Math.min(prev + increment, imageIds.length - 1);
        }
      });
    }, 100);
  };

  const handleMouseUp = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  };

  const handleImageInfo = () => {
    setImageInfo(!imageInfo);
    setUpdate(update ? false : true);
  };

  const ViewerSize = (data: { xs: string; md: string }) => {
    if (width < 900) {
      return data.xs;
    } else {
      return data.md;
    }
  };

  const extractImageIds = (
    dicomDataset: basicDicomFilesRef[],
    series: string,
    studyUId: string
  ) => {
    const SeriesDicoms = dicomDataset.filter(
      (item) =>
        item.seriesNumber === series &&
        item.studyUId === studyUId
    );
    SeriesDicoms.sort(
      (a, b) => parseInt(a.instanceNumber) - parseInt(b.instanceNumber)
    );
    const targetImageIds = SeriesDicoms.map((item) => item.imageId);
    return targetImageIds;
  };

  const handleActiveNumber = (event: SelectChangeEvent<string>) => {
    const [studyUId, series] = event.target.value.split(":");
    setActiveNumber(event.target.value);

    const newImageIds = extractImageIds(
    dicomFiles,
    series,
    studyUId
  );
    setImageIds(newImageIds);
    setIndexValue(0);
  };

  const handleScrollEvent = (event: WheelEvent) => {
    const eventDetail: any = event.detail;
    setIndexValue(eventDetail.newImageIdIndex);
  };

  const handleKeyEvent = (event: KeyboardEvent): void => {
    switch (event.key) {
      case "ArrowLeft":
        var newValue = indexValue - 1;
        setIndexValue(Math.max(newValue, 0));
        break;
      case "ArrowRight":
        var newValue = indexValue + 1;
        setIndexValue(Math.min(newValue, imageIds.length - 1));
        break;
      default:
        break;
    }
  };

  const handleActivePartsNumber = (event: SelectChangeEvent) => {
    const number = parseInt(event.target.value as string);
    const newDicomDatas = props.dicomDatas.filter((value) => {
      return value.subPart === subParts[number];
    });
    setDicomPartsNum(number);
    setActiveNumber("");
    setTotalLoadingImage(0);
    setLoadingImageIndex(0);
    setShowLoading(true);
    setIsFinished(true);
    setJudgeViewer(true);
    setDicomFiles([]);
    setDicomDatas(newDicomDatas);
    setUpdate(update ? false : true);
  };

  const getDcmImages = async () => {
    const firstImageIdsInfo = dicomDatas[0];
    let dicomFileBase = await extractBasicDicom(
      firstImageIdsInfo.path,
      firstImageIdsInfo.series,
      firstImageIdsInfo.start,
      firstImageIdsInfo.end,
      firstImageIdsInfo.studyUId,
      (input_num: number) => {
        setTotalLoadingImage((pa_count) => pa_count + input_num);
      },
      () => {
        setLoadingImageIndex((count) => count + 1);
      }
    ).then(async (result) => {
      const firstSeries = firstImageIdsInfo.series;
      const firstImageIds = extractImageIds(
        result, 
        firstSeries.toString(), 
        firstImageIdsInfo.studyUId
      );
      setImageIds(firstImageIds);
      setActiveNumber(`${firstImageIdsInfo.studyUId}:${firstSeries}`);
      setShowLoading(false);
      setDicomFiles(result);
      const imageFile = await Promise.all(
        dicomDatas.slice(1).map(async (imageIdsInfo) => {
          const imagesOfSeries = await extractBasicDicom(
            imageIdsInfo.path,
            imageIdsInfo.series,
            imageIdsInfo.start,
            imageIdsInfo.end,
            imageIdsInfo.studyUId,
            (input_num) => {
              setTotalLoadingImage((pa_count) => pa_count + input_num);
            },
            () => {
              setLoadingImageIndex((count) => count + 1);
            }
          );
          setDicomFiles((prevFiles) => [...prevFiles, ...imagesOfSeries]);
          return imagesOfSeries;
        })
      );
      result.push(...imageFile.flat());
      return result;
    });

    return dicomFileBase;
  };

  useKey(["ArrowLeft", "ArrowRight"], handleKeyEvent);

  React.useEffect(() => {
    setShowLoading(true);
    getDcmImages().then((imageFilelist) => {
      setDicomFiles(imageFilelist);
      setJudgeViewer(false);
      setIsFinished(false);
    });
  }, [dicomDatas]);

  return (
    <div>
      <Container maxWidth="lg" disableGutters>
        <Grid item spacing={3} sx={{ mt: 1, alignItems: "center" }}>
          <Box sx={{ mb: 1 }}>
            <Typography variant="h5" color="text.secondary" textAlign="left">
              Viewer
            </Typography>
          </Box>
          <div style={{ position: "relative" }}>
            {isFinished && !showLoading ? (
              <div style={{ position: "absolute", zIndex: 1 }}>
                <Typography sx={{ color: "yellow", ml: { xs: 4, sm: 5 } }}>
                  {loadingImageIndex}/{totalLoadingImage}
                </Typography>
              </div>
            ) : (
              <></>
            )}
            {imageIds.length > 0 && showLoading === false ? (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: { sx: "30vh", md: "60vh" },
                  bgcolor: "#ECF5FA",
                }}
              >
                <Box
                  sx={{
                    m: 0,
                    p: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <ViewerTools
                    children={[]}
                    handleActiveTool={(tool) => setViewerActiveTool(tool)}
                  />
                  <Tooltip title="画像情報" placement="left">
                    <IconButton
                      sx={{ p: 0.5, pb: 1 }}
                      onClick={handleImageInfo}
                    >
                      {imageInfo ? (
                        <InfoIcon
                          sx={{
                            fontSize: { xs: 18, sm: 23, md: 25 },
                            color: "#2278CF",
                          }}
                        />
                      ) : (
                        <InfoOutlinedIcon
                          sx={{
                            fontSize: { xs: 18, sm: 23, md: 25 },
                            color: "#2278CF",
                          }}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box sx={{ flexGrow: 1, m: 0, p: 0 }}>
                  <CornerstoneViewport
                    key={subParts[dicomPartsNum]}
                    tools={activeTools}
                    imageIds={imageIds}
                    imageIdIndex={indexValue}
                    activeTool={ViewerActiveTool}
                    isOverlayVisible={imageInfo}
                    eventListeners={[
                      {
                        target: "cornerstone",
                        eventName: cornerstoneTools.EVENTS.STACK_SCROLL,
                        handler: handleScrollEvent,
                      },
                    ]}
                    className="conerstone-viewport"
                    style={{
                      width: "100%",
                      height: ViewerSize({ xs: "30vh", md: "60vh" }),
                    }}
                  />
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  height: { sx: "30vh", md: "60vh" },
                  bgcolor: "#ECF5FA",
                }}
              >
                <Box
                  sx={{
                    m: 0,
                    p: 0,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <ViewerTools children={[]} handleActiveTool={() => {}} />
                  <Tooltip title="画像情報" placement="left">
                    <IconButton sx={{ p: 0.5, pb: 1 }}>
                      {imageInfo ? (
                        <InfoIcon
                          sx={{
                            fontSize: { xs: 20, sm: 23, md: 25 },
                            color: "#2278CF",
                          }}
                        />
                      ) : (
                        <InfoOutlinedIcon
                          sx={{
                            fontSize: { xs: 20, sm: 23, md: 25 },
                            color: "#2278CF",
                          }}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                </Box>
                <Box sx={{ flexGrow: 1, m: 0, p: 0 }}>
                  <Grid
                    sx={{
                      width: "100%",
                      height: ViewerSize({ xs: "30vh", md: "60vh" }),
                      alignItems: "center",
                      justifyContent: "space-between",
                      background: "black",
                    }}
                  >
                    {showLoading ? (
                      <Grid
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                      >
                        <Typography
                          variant="h3"
                          gutterBottom
                          sx={{
                            color: "white",
                            fontSize: { xs: 28, sm: 36, md: 40 },
                          }}
                        >
                          {loadingImageIndex}/{totalLoadingImage} Loading...
                        </Typography>
                      </Grid>
                    ) : (
                      <div></div>
                    )}
                  </Grid>
                </Box>
              </Box>
            )}
          </div>
          <Grid
            container
            sx={{ rowGap: 1, columnGap: 3, mt: 1 }}
            paddingLeft={{ xs: 3, md: 4.5 }}
            alignItems="center"
            justifyContent={{
              xs: "center",
              sm: "center",
              md: "center",
              lg: "center",
            }}
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
          >
            {selectSubPart === "true" ? (
              <FormControl sx={{ m: 1, minWidth: 100 }}>
                <Select
                  value={dicomPartsNum.toString()}
                  defaultValue={"0"}
                  onChange={handleActivePartsNumber}
                  displayEmpty
                  disabled={showLoading || isFinished}
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{ borderRadius: 2, height: 50 }}
                >
                  {subParts.map((subpart, index) => {
                    return (
                      <MenuItem key={index} value={index}>
                        {subpart}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            ) : (
              <></>
            )}
            <FormControl sx={{ my: 1, width: 300 }}>
              <Select
                value={activeNumber}
                defaultValue={""}
                onChange={handleActiveNumber}
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                sx={{ borderRadius: 2, height: 50 }}
              >
                {dicomDatas.map((dicomData, index) => {
                  return (
                    <MenuItem
                      key={index}
                      value={`${dicomData.studyUId}:${dicomData.series}`}
                      disabled={
                        dicomFiles.findIndex(
                          ({ seriesNumber, studyUId }) =>
                            seriesNumber === dicomData.series.toString() &&
                            studyUId === dicomData.studyUId
                        ) === -1
                      }
                    >
                      {dicomData.name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <Button
              variant="outlined"
              disabled={judgeViewer}
              onClick={() => openViewer(dicomFiles, title, "", "")}
              sx={{
                my: 1,
                borderRadius: 2,
                height: 50,
                width: { xs: 300, sm: "auto" },
              }}
            >
              <Grid
                display="flex"
                alignItems="center"
                justifyItems="center"
                gap={2}
              >
                <Typography
                  component="div"
                  variant="body1"
                  fontFamily={MstaFontFamily}
                >
                  Universal Viewer
                </Typography>
                <LaunchOutlinedIcon />
              </Grid>
            </Button>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <Typography sx={{ fontSize: 14 }}>画像スクロール</Typography>
              <Box
                gap={1}
                alignItems="center"
                justifyContent="center"
                display="flex"
                flexDirection="row"
                sx={{ mt: 1, mb: 0.5 }}
              >
                <Button
                  variant="outlined"
                  sx={{ height: 24, width: 60 }}
                  onClick={() => setIndexValue((prev) => Math.max(prev - 1, 0))}
                  onMouseDown={() => handleMouseDown(-1)}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                >
                  <ArrowRightAltIcon sx={{ transform: "rotate(180deg)" }} />
                </Button>
                <Button
                  variant="outlined"
                  sx={{ height: 24, width: 60 }}
                  onClick={() =>
                    setIndexValue((prev) =>
                      Math.min(prev + 1, imageIds.length - 1)
                    )
                  }
                  onMouseDown={() => handleMouseDown(1)}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                >
                  <ArrowRightAltIcon />
                </Button>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}
